"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FactoryBuilder = void 0;

var merge_1 = require("./merge");

var FactoryBuilder =
/** @class */
function () {
  function FactoryBuilder(generator, sequence, params, transientParams, associations, afterBuilds, afterCreates, onCreate) {
    var _this = this;

    this.generator = generator;
    this.sequence = sequence;
    this.params = params;
    this.transientParams = transientParams;
    this.associations = associations;
    this.afterBuilds = afterBuilds;
    this.afterCreates = afterCreates;
    this.onCreate = onCreate;

    this.setAfterBuild = function (hook) {
      _this.afterBuilds = __spreadArrays([hook], _this.afterBuilds);
    };

    this.setAfterCreate = function (hook) {
      _this.afterCreates = __spreadArrays([hook], _this.afterCreates);
    };

    this.setOnCreate = function (hook) {
      if (!_this.onCreate) {
        _this.onCreate = hook;
      }
    };
  }

  FactoryBuilder.prototype.build = function () {
    var generatorOptions = {
      sequence: this.sequence,
      afterBuild: this.setAfterBuild,
      afterCreate: this.setAfterCreate,
      onCreate: this.setOnCreate,
      params: this.params,
      associations: this.associations,
      transientParams: this.transientParams
    };
    var object = this.generator(generatorOptions);

    this._mergeParamsOntoObject(object);

    this._callAfterBuilds(object);

    return object;
  };

  FactoryBuilder.prototype.create = function () {
    return __awaiter(this, void 0, void 0, function () {
      var object, created;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            object = this.build();
            return [4
            /*yield*/
            , this._callOnCreate(object)];

          case 1:
            created = _a.sent();
            return [2
            /*return*/
            , this._callAfterCreates(created)];
        }
      });
    });
  }; // merge params and associations into object. The only reason 'associations'
  // is separated is because it is typed differently from `params` (Partial<T>
  // vs DeepPartial<T>) so can do the following in a factory:
  // `user: associations.user || userFactory.build()`


  FactoryBuilder.prototype._mergeParamsOntoObject = function (object) {
    merge_1.merge(object, this.params, this.associations, merge_1.mergeCustomizer);
  };

  FactoryBuilder.prototype._callAfterBuilds = function (object) {
    this.afterBuilds.forEach(function (afterBuild) {
      if (typeof afterBuild === 'function') {
        afterBuild(object);
      } else {
        throw new Error('"afterBuild" must be a function');
      }
    });
  };

  FactoryBuilder.prototype._callOnCreate = function (object) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (!this.onCreate) {
          throw new Error('Attempted to call `create`, but no onCreate defined');
        }

        return [2
        /*return*/
        , this.onCreate(object)];
      });
    });
  };

  FactoryBuilder.prototype._callAfterCreates = function (object) {
    return __awaiter(this, void 0, void 0, function () {
      var created, _i, _a, afterCreate;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            created = object;
            _i = 0, _a = this.afterCreates;
            _b.label = 1;

          case 1:
            if (!(_i < _a.length)) return [3
            /*break*/
            , 5];
            afterCreate = _a[_i];
            if (!(typeof afterCreate === 'function')) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , afterCreate(created)];

          case 2:
            created = _b.sent();
            return [3
            /*break*/
            , 4];

          case 3:
            throw new Error('"afterCreate" must be a function');

          case 4:
            _i++;
            return [3
            /*break*/
            , 1];

          case 5:
            return [2
            /*return*/
            , created];
        }
      });
    });
  };

  return FactoryBuilder;
}();

exports.FactoryBuilder = FactoryBuilder;